// src/store/modules/auth.js
import authApi from '@/api/auth'
import { SUPER_ROLE } from '@/menu'

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem('admin_token') || '',
    admin: JSON.parse(localStorage.getItem('admin_info') || 'null')
  },
  getters: {
    role: state => (state.admin && state.admin.role) || '',
    permissions: state => (state.admin && Array.isArray(state.admin.permissions) ? state.admin.permissions : []),
    isSuper: (state, getters) => getters.role === SUPER_ROLE,
    // 是否拥有某个菜单权限（超管恒为真）
    can: (state, getters) => (key) => getters.isSuper || (key === 'dashboard') || getters.permissions.includes(key)
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('admin_token', token)
    },
    SET_ADMIN(state, admin) {
      state.admin = admin
      localStorage.setItem('admin_info', JSON.stringify(admin))
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.admin = null
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_info')
    }
  },
  actions: {
    async login({ commit }, credentials) {
      const res = await authApi.login(credentials)
      commit('SET_TOKEN', res.data.token)
      commit('SET_ADMIN', res.data.admin)
      return res
    },
    // 启动时用 token 刷新最新管理员信息（含权限），避免权限变更后缓存过期
    async fetchMe({ commit }) {
      const res = await authApi.getMe()
      commit('SET_ADMIN', res.data)
      return res
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    }
  }
}
